import localeText from "../../../../locale";

import { useEffect, useRef, useState } from "react";
import SubcategoriesService from "../../../../service/SubcategoriesService";
import { Toast } from "primereact/toast";
import "./NewSubcategory.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { locale } from "../../../../utilities/locale/locale";
import { FileUpload } from "primereact/fileupload";
import CategoryService from "../../../../service/CategoryService";

const NewSubcategory = (props) => {
  const subcategoriesService = new SubcategoriesService();
  const categoryService = new CategoryService();

  const toast = useRef(null);

  const [descriptionEN, setDescriptionEN] = useState(props?.isEdit ? props?.descriptionEN : "");
  const [descriptionES, setDescriptionES] = useState(props?.isEdit ? props?.descriptionES : "");
  const [descriptionIT, setDescriptionIT] = useState(props?.isEdit ? props?.descriptionIT : "");
  const [descriptionPT, setDescriptionPT] = useState(props?.isEdit ? props?.descriptionPT : "");
  const [category, setCategory] = useState(props?.isEdit ? props?.selectedCategory : {});
  const [categories, setCategories] = useState([]);
  const [isService, setIsService] = useState(props?.isEdit ? props?.isService : false);

  const [images, setImages] = useState(null);
  const [loadingRegister, setLoadingRegister] = useState(false);
  const [newImage, setNewImage] = useState(false);
  const fileUploadRef = useRef(null);

  const uploadOptions = {
    className: "hidden",
  };

  async function uploadImages(image) {
    try {
      const res = await subcategoriesService.postUploadImage(
        localStorage.getItem("__extraconomy_token"),
        image
      );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingRegister(false);
        return false;
      } else {
        return res.result;
      }
    } catch (e) {
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      } else if (e.status === 500) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedSystemBehaviour"),
          life: 6000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedErrorUploadImg"),
          life: 6000,
        });
      }
    }
  }

  async function registerSubcategory(publish) {
    try {
      setLoadingRegister(true);
      let uploadimage = null;

      if (
        (images?.length > 0 && !props.isEdit) ||
        (props.isEdit && newImage && images?.length > 0)
      ) {
        uploadimage = await uploadImages(images[0]);
      } else if (props.isEdit && !newImage) {
        uploadimage = props.images;
      } else {
        setLoadingRegister(false);
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseUploadAtLeastOne"),
          life: 6000,
        });
        return;
      }

      let res;

      if (!props?.isEdit)
        res = await subcategoriesService.postRegisterSubcategory(
          localStorage.getItem("__extraconomy_token"),
          descriptionEN,
          descriptionIT,
          descriptionPT,
          descriptionES,
          category.id,
          uploadimage,
          isService
        );
      else
        res = await subcategoriesService.postEditSubcategory(
          localStorage.getItem("__extraconomy_token"),
          descriptionEN,
          descriptionIT,
          descriptionPT,
          descriptionES,
          category.id,
          props.id,
          uploadimage,
          isService
        );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingRegister(false);
        if (res.messageCode === 500000) console.log(res);
        return;
      }
      if (res.messageCode === 200000) {
        window.location.href = "/listsubcategories";
        if (res.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          setLoadingRegister(false);
          return;
        }
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingRegister(false);
        return;
      }
    } catch (e) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("unexpectedErrorRegisterProduct"),
        life: 6000,
      });
      setLoadingRegister(false);
      console.log(e);
    }
  }

  const createCategoryList = async () => {
    const { result } = await categoryService.getCategories();

    const editedCategories = result.map((oldFormatCategory) => {
      const {
        id,
        descriptionEnglish,
        descriptionSpanish,
        descriptionItalian,
        descriptionPortuguese,
      } = oldFormatCategory;

      let description = "";

      switch (locale) {
        case "pt":
          description = descriptionPortuguese;
          break;
        case "it":
          description = descriptionItalian;
          break;
        case "es":
          description = descriptionSpanish;
          break;
        default:
          description = descriptionEnglish;
          break;
      }

      return { label: description, id };
    });

    const listedCategories = [...editedCategories];

    setCategories(listedCategories);
  };

  useEffect(() => {
    createCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Toast ref={toast} />
      <div className="border-round" style={{ backgroundColor: "#46a748" }}>
        <h1 className="py-6 text-center text-0 lg:text-6xl md:text-6xl text-4xl">
          {props.isEdit ? localeText("edit") : localeText("addNewSubcategory")}
        </h1>
      </div>
      <div className="card border-1 border-300">
        <div className="mb-4">
          <h3 className="my-4">{localeText("subcategoryInfo")}</h3>
          <p className="text-600">{localeText("subcategoryFields")}</p>
          <div className="grid mt-6">
            <div className="col-12">
              <label htmlFor="descriptionEN">{localeText("descriptionEN")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionEN"
                value={descriptionEN}
                onChange={(e) => setDescriptionEN(e.target.value)}
              />
              <label htmlFor="descriptionES">{localeText("descriptionES")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionES"
                value={descriptionES}
                onChange={(e) => setDescriptionES(e.target.value)}
              />
              <label htmlFor="descriptionIT">{localeText("descriptionIT")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionIT"
                value={descriptionIT}
                onChange={(e) => setDescriptionIT(e.target.value)}
              />
              <label htmlFor="descriptionPT">{localeText("descriptionPT")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionPT"
                value={descriptionPT}
                onChange={(e) => setDescriptionPT(e.target.value)}
              />
              <label>{localeText("category")}</label>
              <Dropdown
                className="text-center w-full my-2"
                value={category}
                options={categories}
                onChange={(e) => {
                  setCategory(e.value);
                }}
                style={{ minWidth: "108px" }}
              />
              <div className="mt-4 mb-2">
                <label className="mr-1">{localeText("isService")}</label>
                <input
                  className="p-checkbox"
                  type="checkbox"
                  name="service"
                  onClick={() => {
                    setIsService((oldState) => !oldState);
                  }}
                  defaultChecked={isService}
                  value={isService}
                />
              </div>
            </div>
            <div className="col-12">
              <label htmlFor="imageSubcategory">
                <span>{localeText("subcategoryImage")}</span>
              </label>

              <FileUpload
                uploadOptions={uploadOptions}
                chooseLabel={localeText("choose")}
                cancelLabel={localeText("cancel")}
                className="mt-2"
                name="imageSubcategory"
                onSelect={(e) => {
                  if (e.files.length <= 1 && e.files.length > 0) {
                    let error = false;

                    Array.from(e.files).forEach((file) => {
                      if (file.size / 1024 / 1024 > 1) {
                        setImages(null);
                        fileUploadRef.current.clear();
                        toast.current.show({
                          severity: "error",
                          summary: localeText("error"),
                          detail: localeText("fileSizeTooBig"),
                          life: 6000,
                        });
                        error = true;
                        return false;
                      }
                    });

                    if (!error) {
                      const arrImages = images ? [...images] : [];
                      Array.from(e.files).forEach((file) => {
                        arrImages.push(file);
                      });
                      setNewImage(true);
                      setImages(arrImages);
                    }
                  } else {
                    setImages(null);
                    toast.current.show({
                      severity: "error",
                      summary: localeText("error"),
                      detail: localeText("youCanOnlyChooseUpTo5"),
                      life: 6000,
                    });
                    fileUploadRef.current.clear();
                  }
                }}
                onClear={() => {
                  setImages(null);
                  if (props.isEdit) setNewImage(false);
                }}
                onRemove={() => {
                  fileUploadRef.current.clear();
                  setImages(null);
                  if (props.isEdit) setNewImage(false);
                }}
                onError={() => {
                  fileUploadRef.current.clear();
                  setImages(null);
                  if (props.isEdit) setNewImage(false);
                }}
                onValidationFail={() => {
                  fileUploadRef.current.clear();
                  setImages(null);
                  if (props.isEdit) setNewImage(false);
                }}
                accept="image/*"
                ref={fileUploadRef}
                multiple
                emptyTemplate={
                  <div className="text-center">
                    <i className="pi pi-upload text-400" style={{ fontSize: "3em" }}></i>
                    <h3 className="text-400">{localeText("dragImg")}</h3>
                  </div>
                }
              />
              <p className="text-600 mt-2">(max. 5 MB)</p>

              <div className="d-flex align-items-end flex-column">
                <Button
                  label={localeText("registerSubcategory")}
                  loading={loadingRegister}
                  className="mr-2 w-full lg:w-auto md:w-auto m-1"
                  onClick={() => registerSubcategory(true)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewSubcategory;
